<template>
    <div class="share">
        <div class="player-list">
            <div class="notexist" id="notexist" v-if="isNotExist">
                {{"分享播放地址已停用或者过期！"}}
            </div>
            <div class="player-card" v-if="isShow" :class="{'fs-fallback': fsFallback, 'fs-rotate': fsRotate}" :style="cardStyle">
                <div class="player-title">{{movie_title}}</div>
                <div class="video-wrap" :style="videoWrapStyle">
                    <eu-player v-if="playerVisible" ref="player" :source="scriptUrl"
                        :autoplay="false"
                        container-id="share-player-canvas"
                        @playComplete="onPlayComplete"
                        @loaded="onPlayerLoaded"></eu-player>
                    <div class="player-cover" v-if="!started" @click="startPlay" :style="coverStyle">
                        <i class="el-icon-video-play"></i>
                    </div>
                    <div class="replay-mask" v-if="playerVisible && isFinished" @click="replay">
                        <i class="el-icon-refresh-right"></i>
                        <span>重新播放</span>
                    </div>
                </div>
                <div class="controls" v-if="playerVisible">
                    <button class="ctrl-btn" type="button" @click="togglePlay">
                        <i :class="isFinished || !isPlaying ? 'el-icon-video-play' : 'el-icon-video-pause'"></i>
                    </button>
                    <span class="time">{{fmt(displayTime)}}</span>
                    <input type="range" class="progress" :min="0" :max="duration || 1000"
                        :value="displayTime"
                        :style="{background: progressBg}"
                        @input="onSeekInput"
                        @change="onSeekChange"
                        @mousedown="onDragStart" @touchstart="onDragStart" />
                    <span class="time">{{fmt(duration)}}</span>
                    <button class="ctrl-btn" type="button" @click="toggleFullscreen" title="全屏">
                        <i class="el-icon-full-screen"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// eu-core H5 播放器（替换 MoviePlayer.swf）
import EuPlayer from '@/components/Player/EuPlayer'

import EUY from '@/common/scripts/euy'
    export default {
        // 组件
        components: {
          EuPlayer,
        },
        data () {
            return {
                code: "",
                movie_title: "",
                scriptUrl: "",
                previewUrl: "",
                playerVisible: false,
                started: false,
                isShow: false,
                isNotExist: false,
                // 播放状态（轮询 engine.getPlayState 驱动）
                isPlaying: false,
                isFinished: false,
                currentTime: 0,
                duration: 0,
                // 拖动进度条
                isDragging: false,
                dragValue: 0,
                wasPlayingOnDrag: false,
                lastSeekTs: 0,
                progressTimer: null,
                // 全屏
                isFullscreen: false,
                fsFallback: false,
                // 竖屏移动端全屏时横屏：orientation.lock失败走CSS旋转
                wantLandscape: false,
                rotateFallback: false,
                // 影片宽高比（宽/高），加载完成前按16:9占位
                videoAspect: 16 / 9,
                isPortrait: typeof window !== 'undefined' && window.innerHeight > window.innerWidth,
                isTouchDevice: typeof window !== 'undefined' && ('ontouchstart' in window || navigator.maxTouchPoints > 0),
            }
        },
        computed: {
            coverStyle () {
                if (!this.previewUrl) return {}
                return {
                    background: 'linear-gradient(rgba(0,0,0,0.35), rgba(0,0,0,0.35)), url("' + this.previewUrl + '") center / contain no-repeat #000'
                }
            },
            displayTime () {
                return this.isDragging ? this.dragValue : this.currentTime
            },
            progressPct () {
                const total = this.duration || 1
                return Math.max(0, Math.min(100, this.displayTime / total * 100))
            },
            progressBg () {
                return 'linear-gradient(to right, #409eff ' + this.progressPct + '%, rgba(255,255,255,0.3) ' + this.progressPct + '%)'
            },
            // 全屏+竖屏触屏设备+横屏锁失败 → CSS旋转90度伪横屏（用户物理转屏后isPortrait变false自动取消）
            fsRotate () {
                return this.isFullscreen && this.rotateFallback && this.isPortrait
            },
            // 视频区宽高比跟随影片：竖屏(9:16)限高70vh而非按宽度撑高，横屏按比例padding撑高
            videoWrapStyle () {
                if (this.isFullscreen) return {}
                const a = this.videoAspect
                if (a >= 1) {
                    return { paddingTop: (100 / a) + '%', height: 'auto' }
                }
                return { paddingTop: '0', height: '70vh' }
            },
            // 竖屏影片时卡片宽度收窄到 视频高×宽高比，避免大片黑边
            cardStyle () {
                if (this.isFullscreen || this.videoAspect >= 1) return {}
                return { maxWidth: 'calc(70vh * ' + this.videoAspect + ')' }
            }
        },
        methods: {
            getQueryString (name) {
                var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
                var r = window.location.search.substr(1).match(reg);
                if (r != null) return unescape(r[2]); return null;
            },

            getShareByCode (code) {
                // storage-service(Java)公开接口，对齐老版PHP /pro/api/public/getShareByCode
                let url = "/api/storage/storage/share/getShareByCode";
                let headers = {
                }
                let params = {
                    'code': code,
                }
                this.AJAX.get(url, headers, params).then((data)=> {
                    if(data.code == 0 || data.code == 10000) {
                        let result = data.datas || data.result || {}
                        this.scriptUrl = result.url;
                        this.movie_title = result.title;
                        this.previewUrl = result.preview || "";
                        this.isShow = true;
                        // 数据就绪即挂载播放器（autoplay=false），展示封面等待点击播放
                        this.playerVisible = true;
                        this.startTimer();
                    }else {
                        this.isNotExist = true;
                    }
                }).catch((err)=> {
                    this.$message({
                        message: err.msg||err.message,
                        type: 'error'
                    })
                    this.isNotExist = true;
                })
            },

            player () {
                return this.$refs.player
            },

            startPlay () {
                this.started = true
                const p = this.player()
                if (p) p.play()
            },

            togglePlay () {
                const p = this.player()
                if (!p) return
                if (this.isFinished) {
                    this.replay()
                    return
                }
                if (!this.started) {
                    this.startPlay()
                    return
                }
                if (this.isPlaying) {
                    p.pause()
                } else {
                    // 续播：保留步内进度，区别于play()回到步头
                    p.resume()
                }
                this.pollState()
            },

            replay () {
                const p = this.player()
                if (!p) return
                this.isFinished = false
                p.replay()
                this.pollState()
            },

            onPlayComplete () {
                this.isFinished = true
                this.isPlaying = false
            },

            onDragStart () {
                this.isDragging = true
                this.wasPlayingOnDrag = this.isPlaying || this.isFinished
                this.dragValue = this.currentTime
                // 拖动期间暂停引擎：每个input都走完整changeStep会卡帧
                const p = this.player()
                if (p && this.isPlaying) p.pause()
            },

            onSeekInput (e) {
                this.dragValue = +e.target.value
                // 节流预览seek：只更新滑块显示，每180ms让引擎画一次预览帧
                const now = Date.now()
                if (now - this.lastSeekTs >= 180) {
                    this.lastSeekTs = now
                    const p = this.player()
                    if (p) p.seek(this.dragValue)
                }
            },

            onSeekChange (e) {
                const v = +e.target.value
                this.isDragging = false
                const p = this.player()
                if (!p) return
                p.seek(v)
                // 拖动前在播放或已播完：定位后继续播放；暂停态拖动保持暂停
                if (this.wasPlayingOnDrag || this.isFinished) {
                    this.isFinished = false
                    p.play()
                }
                this.pollState()
            },

            pollState () {
                const p = this.player()
                if (!p || !p.getPlayState) return
                const st = p.getPlayState()
                if (!st) return
                this.isPlaying = st.playing
                this.duration = st.total
                if (!this.isDragging) {
                    this.currentTime = st.current
                }
                if (st.playing) {
                    this.isFinished = false
                } else if (st.total > 0 && st.current >= st.total - 300) {
                    this.isFinished = true
                } else {
                    this.isFinished = false
                }
            },

            toggleFullscreen () {
                const card = document.querySelector('.player-card')
                if (!card) return
                if (this.isFullscreen) {
                    this.exitFullscreen()
                    return
                }
                // 竖屏触屏设备：进全屏后尝试锁横屏（在onFullscreenChange里执行）
                this.wantLandscape = this.isTouchDevice && this.isPortrait
                const req = card.requestFullscreen || card.webkitRequestFullscreen || card.webkitEnterFullscreen
                if (req) {
                    req.call(card)
                } else {
                    // 不支持元素全屏的环境（如iOS WebView）：CSS伪全屏+旋转横屏
                    this.fsFallback = true
                    this.isFullscreen = true
                    this.rotateFallback = this.wantLandscape
                    this.wantLandscape = false
                }
            },

            exitFullscreen () {
                this.wantLandscape = false
                if (this.fsFallback) {
                    this.fsFallback = false
                    this.isFullscreen = false
                    this.rotateFallback = false
                    return
                }
                this.unlockOrientation()
                const exit = document.exitFullscreen || document.webkitExitFullscreen
                if (exit && (document.fullscreenElement || document.webkitFullscreenElement)) {
                    exit.call(document)
                } else {
                    this.isFullscreen = false
                    this.rotateFallback = false
                }
            },

            // Android Chrome: 全屏内锁横屏；不支持/失败 → rotateFallback走CSS旋转
            lockLandscape () {
                const so = window.screen && (window.screen.orientation || window.screen.msOrientation || window.screen.mozOrientation)
                if (so && so.lock) {
                    try {
                        const p = so.lock('landscape')
                        if (p && p.catch) {
                            p.catch(() => { this.rotateFallback = true })
                        }
                        // 部分实现lock返回void或resolve但不旋转：延迟校验仍为竖屏则补CSS旋转
                        setTimeout(() => {
                            if (this.isFullscreen && window.innerHeight > window.innerWidth) {
                                this.rotateFallback = true
                            }
                        }, 500)
                    } catch (e) {
                        this.rotateFallback = true
                    }
                } else {
                    this.rotateFallback = true
                }
            },

            unlockOrientation () {
                const so = window.screen && (window.screen.orientation || window.screen.msOrientation || window.screen.mozOrientation)
                if (so && so.unlock) {
                    try { so.unlock() } catch (e) {}
                }
            },

            onFullscreenChange () {
                const el = document.fullscreenElement || document.webkitFullscreenElement
                this.isFullscreen = !!el
                if (this.isFullscreen && this.wantLandscape) {
                    this.wantLandscape = false
                    this.lockLandscape()
                } else if (!this.isFullscreen) {
                    // ESC/系统手势退出全屏：释放方向锁和旋转状态
                    this.rotateFallback = false
                    this.unlockOrientation()
                }
            },

            onWinResize () {
                this.isPortrait = window.innerHeight > window.innerWidth
            },

            startTimer () {
                if (this.progressTimer) return
                this.progressTimer = setInterval(() => this.pollState(), 200)
            },

            stopTimer () {
                if (this.progressTimer) {
                    clearInterval(this.progressTimer)
                    this.progressTimer = null
                }
            },

            // 播放器加载完成：带出影片实际宽高（EuPlayer loaded事件），据此调整视频区比例
            onPlayerLoaded (size) {
                if (size && size.width > 0 && size.height > 0) {
                    this.videoAspect = size.width / size.height
                }
            },
            fmt (ms) {
                const s = Math.floor((ms || 0) / 1000)
                const m = Math.floor(s / 60)
                const sec = s % 60
                return (m < 10 ? '0' + m : m) + ':' + (sec < 10 ? '0' + sec : sec)
            }
        },
        mounted () {
            this.code = this.getQueryString("code");
            if(this.code) {
                this.getShareByCode(this.code);
            }
            document.addEventListener('fullscreenchange', this.onFullscreenChange)
            document.addEventListener('webkitfullscreenchange', this.onFullscreenChange)
            window.addEventListener('resize', this.onWinResize)
        },
        beforeDestroy () {
            this.stopTimer()
            document.removeEventListener('fullscreenchange', this.onFullscreenChange)
            document.removeEventListener('webkitfullscreenchange', this.onFullscreenChange)
            window.removeEventListener('resize', this.onWinResize)
            if (this.isFullscreen) this.exitFullscreen()
            this.unlockOrientation()
        }
    }
</script>

<style lang="stylus">
    .share
        position: absolute
        width: 100%
        height: 100%
        background: #f0f2f5
        .player-list
            top: 0
            left: 0
            width: 100%
            height: 100%
            overflow: auto
            position: absolute
            display: flex
            flex-direction: column
            align-items: center
            justify-content: center
            padding: 16px
            box-sizing: border-box

        .player-card
            width: 100%
            max-width: 900px
            background: #000000
            border-radius: 8px
            overflow: hidden
            box-shadow: 0 4px 20px rgba(0,0,0,0.3)

            &.fs-fallback
                position: fixed
                top: 0
                left: 0
                z-index: 9999

            // 原生全屏 + iOS伪全屏：视频区撑满剩余高度（App的ResizeObserver会自动放大渲染）
            &.fs-fallback,
            &:fullscreen,
            &:-webkit-full-screen
                display: flex
                flex-direction: column
                width: 100%
                max-width: none
                height: 100%
                border-radius: 0
                .video-wrap
                    flex: 1
                    padding-top: 0
                    min-height: 0

            // 竖屏移动端伪横屏：卡片整体旋转90°，宽高互换（须在fs-fallback之后以覆盖其定位）
            &.fs-rotate
                position: fixed
                top: 50%
                left: 50%
                width: 100vh
                height: 100vw
                max-width: none
                border-radius: 0
                transform: translate(-50%, -50%) rotate(90deg)
                z-index: 9999

            .player-title
                padding: 0 16px
                height: 44px
                line-height: 44px
                color: #ffffff
                font-size: 15px
                white-space: nowrap
                overflow: hidden
                text-overflow: ellipsis
                background: #1a1a1a

            .video-wrap
                position: relative
                width: 100%
                padding-top: 56.25%
                background: #000000
                .eu-player
                    position: absolute
                    top: 0
                    left: 0
                .player-cover
                    position: absolute
                    top: 0
                    left: 0
                    width: 100%
                    height: 100%
                    display: flex
                    align-items: center
                    justify-content: center
                    cursor: pointer
                    color: #ffffff
                    font-size: 72px
                    background: rgba(0,0,0,0.25)
                    &:hover
                        background: rgba(0,0,0,0.15)
                .replay-mask
                    position: absolute
                    top: 0
                    left: 0
                    width: 100%
                    height: 100%
                    display: flex
                    flex-direction: column
                    align-items: center
                    justify-content: center
                    cursor: pointer
                    color: #ffffff
                    font-size: 16px
                    background: rgba(0,0,0,0.55)
                    i
                        font-size: 56px
                        margin-bottom: 10px
                    &:hover
                        background: rgba(0,0,0,0.4)

            .controls
                display: flex
                align-items: center
                padding: 0 14px
                height: 48px
                background: #1a1a1a
                box-sizing: border-box
                .ctrl-btn
                    flex: none
                    border: none
                    background: transparent
                    color: #ffffff
                    font-size: 24px
                    cursor: pointer
                    padding: 4px
                    line-height: 1
                    outline: none
                    &:hover
                        color: #409eff
                .time
                    flex: none
                    color: #cccccc
                    font-size: 12px
                    min-width: 40px
                    text-align: center
                    margin: 0 6px
                .progress
                    flex: 1
                    -webkit-appearance: none
                    appearance: none
                    height: 4px
                    border-radius: 2px
                    outline: none
                    cursor: pointer
                    margin: 0 6px
                    &::-webkit-slider-thumb
                        -webkit-appearance: none
                        appearance: none
                        width: 14px
                        height: 14px
                        border-radius: 50%
                        background: #ffffff
                        cursor: pointer
                    &::-moz-range-thumb
                        width: 14px
                        height: 14px
                        border: none
                        border-radius: 50%
                        background: #ffffff
                        cursor: pointer

        .notexist
            padding-left: 0
            padding-top: 30px
            width: 100%
            line-height: 32px
            color: #999999
            text-align: center

        @media screen and (max-width: 750px)
            .player-list
                padding: 0
                justify-content: flex-start
            .player-card
                max-width: 100%
                border-radius: 0
                margin-top: 0
                .player-title
                    height: 40px
                    line-height: 40px
                    font-size: 14px
                .controls
                    height: 44px
                    padding: 0 10px
                    .ctrl-btn
                        font-size: 22px
</style>



// WEBPACK FOOTER //
// Share.vue?9063b4b4